import { render, staticRenderFns } from "./projectItem.vue?vue&type=template&id=d376f42a&"
import script from "./projectItem.vue?vue&type=script&lang=js&"
export * from "./projectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d376f42a')) {
      api.createRecord('d376f42a', component.options)
    } else {
      api.reload('d376f42a', component.options)
    }
    module.hot.accept("./projectItem.vue?vue&type=template&id=d376f42a&", function () {
      api.rerender('d376f42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/leftSideBar/includes/projectItem.vue"
export default component.exports